import { createSelector } from 'reselect'
import generateMarks from '../utility/generateMarks'

const getTimestamps = state => {
  return state.timestamp.timestamps
}

const getMinTimestamps = state => {
  const { minTime } = state.service.serviceCardActive

  return minTime
}

const getMaxTimestamps = state => {
  const { maxTime } = state.service.serviceCardActive

  return maxTime
}

const getSeasonalServiceSelected = state => {
  const { name, minTime, maxTime } = state.service.serviceCardActive

  return name === 'RiverIce' || name === 'RiverIceHistorical'
}

export const getGeneratedMarks = createSelector([getTimestamps, getMinTimestamps, getMaxTimestamps, getSeasonalServiceSelected], (timestamps, minTime, maxTime, seasonal) => {
  try {
    const minTimestamp = seasonal && minTime ? new Date(minTime).toISOString() : null
    const maxTimestamp = seasonal && maxTime ? new Date(maxTime).toISOString(): null
    const marks = generateMarks(timestamps, minTimestamp, maxTimestamp)
    // const marks = generateMarks(timestamps)

    return marks
  } catch (error) {
    return []
  }
})



// WEBPACK FOOTER //
// ./src/selectors/generatedMarksSelector.js